<script>
import * as PIXI from 'pixi.js';

export default {
	// Gets us the provider property from the parent <pixi-stage> component.
	inject: ['EventBus', 'provider'],

	props: {
		scale: {
			type: Number,
			default: 1
		},

		imageUrl: {
			type: String,
			required: true
		},

		localX: {
			type: Number,
			default: 400
        },

        localY: {
            type: Number,
            default: 0
        }
	},

	data() {
		return {}
	},

	render: function(h) {
		return h('template', this.$slots.default)
	},

	methods: {
		onPixiReady() {
			this.app = this.provider.app;
			this.stage = this.app.stage;

			this.trash.anchor.set(1, 1);
            this.trash.position.set(this.localX, this.provider.minLineHeight + this.localY);
            this.trash.scale.set(this.scale);

            this.trash.visible = true;

			this.provider.utilsContainer.addChild(this.trash);
		},
	},

	beforeDestroy() {

		if(this.trash) {
			this.trash.removeAllListeners();
			this.provider.utilsContainer.removeChild(this.trash);
		}

	},

	mounted() {
		// Texture
		this.texture = new PIXI.Texture.fromImage(this.imageUrl);
		this.texture.baseTexture.scaleMode = PIXI.SCALE_MODES.NEAREST;

        Object.defineProperty(this, 'trash', { value: new PIXI.Sprite(this.texture), configurable: false });

        this.trash.name = 'Trash';

		if (this.provider.ready) {
			this.onPixiReady();
		} else {
			this.EventBus.$on('ready', this.onPixiReady);
		}
	}
}
</script>



// WEBPACK FOOTER //
// assets/vue/apps/participate/pixi-trash.vue